<template>
  <div class="grm-loading-component">
    <div class="grm-loading">
      <img width="100" height="auto" alt="로딩 이미지" :src="ux.loadingImagePath || require('@/assets/images/loading_gooroomee.gif')" />
    </div>
    <div v-if="msg && msg !== ''"
      v-html="msg"
      style="
        color: #fff;
        font-size: 14px;
        text-shadow: 2px 2px 2px black;
      "
    ></div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'GrmLoading',
  props: ['msg'],
  computed: {
    ...mapGetters('ux', [
      'ux'
    ])
  }
}
</script>

<style lang="scss" scoped>
.grm-loading-component {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  line-height: 1.5;
}
</style>